import React, { useContext } from "react";
import {
    ButtonRenderProps,
    ContentSection,
    Grid,
    GridColumn,
    GridRow,
    LabeledBadge,
    LabeledDate,
    LabeledText
} from "sprint-common-web";

import {
    resolveOrderContentTitle,
    resolveOrderContentVersion
} from "../../../../common/api/orders-api/order/ContentReference";
import { LabeledTrailerInfoBadge } from "../../../../common/components/trailer-info/LabeledTrailerInfoBadge";
import { stringifyOrderResolutionDimensions } from "../../../common/types/OrderResolutionDimensions";
import { resolveCloudOrderSourceBadgeColor } from "../../common/utils/resolveCloudOrderSourceBadgeColor";
import { CloudOrderSource } from "../../listing/OrderListingItem";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";
import { OrderDetailsStatus } from "./OrderDetailsStatus";

interface OrderDetailsSectionProps {
    height: number;
}

export const OrderDetailsSection: React.VFC<OrderDetailsSectionProps> = ({ height }: OrderDetailsSectionProps) => {
    const { orderDashboardItem, isLoading } = useContext(OrderDashboardContext);

    const orderStatus: ButtonRenderProps = {
        render: OrderDetailsStatus
    };

    const contentText = `${resolveOrderContentTitle(orderDashboardItem.content)} - ${resolveOrderContentVersion(
        orderDashboardItem.content
    )}`;

    const { targetResolution } = orderDashboardItem;
    const targetResolutionText = targetResolution ? stringifyOrderResolutionDimensions(targetResolution) : "-";

    return (
        <ContentSection
            header="Details"
            style={{ height }}
            isLoading={isLoading}
            buttons={[orderStatus]}
            testId={"details-section"}
        >
            <Grid>
                <GridRow>
                    <GridColumn lg={6}>
                        <LabeledText label="PO number" testId="order-po-number" value={orderDashboardItem.pONumber} />
                        <LabeledText label="Content" testId="order-content" value={contentText} maxLength={50} />
                        <LabeledText label="Airline" testId="order-airline" value={orderDashboardItem.airline.name} />
                        {!!orderDashboardItem.isTrailer && <LabeledTrailerInfoBadge />}
                        <LabeledDate
                            label="Start date"
                            testId="order-startDate"
                            value={new Date(orderDashboardItem.startDate)}
                        />
                    </GridColumn>
                    <GridColumn lg={6}>
                        <LabeledText label="System" testId="order-system" value={orderDashboardItem.system.name} />
                        <LabeledText
                            label="Encode specification"
                            testId="order-encodeSpecification-name"
                            value={orderDashboardItem.encodeSpecification.name}
                        />
                        <LabeledText
                            label="Encode specification aspect ratio"
                            testId="order-encodeSpecification-aspectRatio"
                            value={orderDashboardItem.encodeSpecification.targetAspectRatio.name}
                        />
                        <LabeledText
                            label="Target resolution"
                            testId="order-targetResolution"
                            value={targetResolutionText}
                        />
                        <LabeledBadge
                            label="Source"
                            testId="order-source"
                            badgeSize={14}
                            value={CloudOrderSource[orderDashboardItem.source]}
                            color={resolveCloudOrderSourceBadgeColor(orderDashboardItem.source)}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
